import {default as Trim} from '../../helpers/trim';
import hasHTMLTags from '../../helpers/hasHTMLTags';
import isValidEmailAddress from './isValidEmailAddress';
import isValidPhone from './isValidPhone';
import isInteger from './isInteger';
import isValidURL from './isValidURL';

let validate = function (data, scroll, txt) {
    var valid = true

    jQ(data).each(function (index, elem) {
        if (!jQ(elem).hasClass('valid'))
            return

        var tag = jQ(elem).prop('tagName')
        var elemName = jQ(elem).attr('name')

        var txt_error = ''
        if (typeof(txt) !== 'undefined') {
            txt_error = txt
        }
        else if (typeof(jQ('#' + elemName + '-error').attr('default')) !== 'undefined' && jQ('#' + elemName + '-error').attr('default').length) {
            txt_error = jQ('#' + elemName + '-error').attr('default')
        }

        switch (tag) {
            case 'INPUT':
                var inputValue = jQ(elem).val();
                if (jQ(elem).attr('placeholder') && inputValue == jQ(elem).attr('placeholder')) {
                    inputValue = ''
                }
                if (jQ(elem).hasClass('NumGroup')) {
                    var groupClass = jQ(elem).attr('default-gn')
                    var groupValidateFlag = true
                    if (typeof(groupClass) == 'undefined')
                        return

                    var groupData = jQ('.' + groupClass)
                    jQ(groupData).each(function (groupDataIndex, groupDataElem) {
                        var groupElemLength = ~~jQ(groupDataElem).attr('maxlength')
                        var groupElemValLength = ~~jQ(groupDataElem).val() > 0 ? jQ(groupDataElem).val().length : 0

                        if (groupElemValLength == 0 || groupElemValLength < groupElemLength) {
                            jQ(elem).focus()
                            Trigger_Error(elem, '', scroll)
                            jQ('body').on('change', '.' + groupClass, function () {
                                if (jQ('#' + elemName + '-error'))
                                    jQ('#' + elemName + '-error').css({'visibility': 'hidden'})
                            })
                            groupValidateFlag = false
                            valid = false
                            return false
                        }
                    })
                    return groupValidateFlag
                }
                else if (inputValue.length == 0 || Trim(inputValue).length == 0) {
                    jQ(elem).focus()
                    Trigger_Error(elem, txt_error, scroll)
                    valid = false
                    return false
                }
                else if (hasHTMLTags(inputValue)) {
                    jQ(elem).focus()
                    Trigger_Error(elem, 'Please enter text only', scroll)
                    valid = false
                    return false
                }
                else if (jQ(elem).hasClass('email') && !isValidEmailAddress(inputValue)) {
                    jQ(elem).focus()
                    Trigger_Error(elem, 'Please enter valid Email', scroll)
                    valid = false
                    return false
                }
                else if (jQ(elem).hasClass('num') && !isInteger(inputValue)) {
                    jQ(elem).focus()
                    Trigger_Error(elem, 'Please enter only numbers', scroll)
                    valid = false
                    return false
                }
                else if (jQ(elem).hasClass('phone') && !isValidPhone(inputValue)) {
                    jQ(elem).focus()
                    Trigger_Error(elem, 'Please valid Phone Number', scroll)
                    valid = false
                    return false
                }
                else if (jQ(elem).hasClass('url') && !isValidURL(inputValue)) {
                    jQ(elem).focus()
                    Trigger_Error(elem, 'Please valid URL', scroll)
                    valid = false
                    return false
                }else if (jQ(elem).attr('type') == 'radio') {
                    if(!jQ('input[name="'+elemName+'"]').is(':checked')){
                        jQ(elem).focus();
                        Trigger_Error(elem, txt_error, scroll);
                        valid = false;
                        return false;
                    }
                }
                break
            case 'SELECT':
                if (jQ(elem)[0].selectedIndex < 1) {
                    jQ(elem).focus()
                    Trigger_Error(elem, txt_error, scroll)
                    jQ('body').on('change', '#' + elemName, function () {
                        if (jQ('#' + elemName + '-error'))
                            jQ('#' + elemName + '-error').css({'visibility': 'hidden'})
                    })
                    valid = false
                    return false
                }
                break
            case 'TEXTAREA':
                var textareaValue = jQ(elem).val()
                if (jQ(elem).attr('placeholder') && textareaValue == jQ(elem).attr('placeholder')) {
                    textareaValue = ''
                }
                if ((textareaValue.length == 0 || hasHTMLTags(textareaValue)) || Trim(textareaValue).length == 0) {
                    jQ(elem).focus()
                    Trigger_Error(elem, txt_error, scroll)
                    valid = false
                    return false
                }
                break
        }

    })

    return valid;
}

export default validate;
